import { PanelCategory, PanelConfig } from '@helios/panel-base'
import { DevtoolsPanelComponent } from './lib/devtools-panel.component'
import { DevtoolsKey } from './panel-key'

export const DevtoolsPanelConfig: PanelConfig = {
  key: DevtoolsKey,
  title: 'Devtools',
  description: 'Helios Devtools to view SSE events and Http requests',
  category: PanelCategory.HELP,
  panelComponent: DevtoolsPanelComponent,
  accessPermission: 'accessDevtoolsPanel',
}
